__turbopack_context__.v({
  "matchCount": "smart-search-panel-module-scss-module__uTNtAq__matchCount",
  "root": "smart-search-panel-module-scss-module__uTNtAq__root",
});
